declare global {
  interface Window {
    __ND_SESSION__?: { token: string; apiBaseUrl: string };
  }
}

export interface Session {
  token: string;
  apiBaseUrl: string;
}

const FALLBACK_API = 'https://lti.namedrop.io';

export function readSession(): Session | null {
  if (typeof window === 'undefined') return null;

  if (window.__ND_SESSION__ && window.__ND_SESSION__.token) {
    return {
      token: window.__ND_SESSION__.token,
      apiBaseUrl: window.__ND_SESSION__.apiBaseUrl || FALLBACK_API,
    };
  }

  const params = new URLSearchParams(window.location.search);
  const token = params.get('s');
  if (token) {
    const envApi = (import.meta.env.VITE_API_BASE_URL ?? '').trim();
    return {
      token,
      apiBaseUrl: envApi || FALLBACK_API,
    };
  }

  return null;
}

/** Remove ?s=<jwt> from the URL bar so the token doesn't leak via Referer
 * header or browser history. Safe to call after the session is captured. */
export function stripSessionFromUrl(): void {
  if (typeof window === 'undefined' || !window.location.search.includes('s=')) return;
  try {
    history.replaceState(null, '', window.location.pathname);
  } catch {
    // history API not available — ignore.
  }
}
